import Vue from 'vue'

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

const convertJsonToRow = (object, ignore) => {
  let text = ''
  for (let property in object) {
    if (object.hasOwnProperty(property) && !ignore.includes(property)) {
      let value = object[property]
      if (value) {
        text += property + ": " + value + "\n\r"
      }
    }
  }
  return text
}

export default Vue.filter("jsonView", (value, ignore = []) => {
  if (isJson(value)) {
    return convertJsonToRow(JSON.parse(value), ignore)
  } else {
    return value;
  }
})





// WEBPACK FOOTER //
// ./src/filter/JsonViewFilter.js